import React, { useEffect, useState } from "react";
import useAuth from "../../hooks/useAuth";
import * as filestack from "filestack-js";

const client = filestack.init("A02oI9WUVQemHuUcmNRDKz");

const Upload = () => {
  const [serieses, setSerieses] = useState([]);
  const [series, setSeries] = useState("");
  const [departments, setDepartments] = useState([]);
  const [department, setDepartment] = useState("");
  const [semesters, setSemesters] = useState([]);
  const [semester, setSemester] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [subject, setSubject] = useState({});
  const [title, setTitle] = useState("");
  const [details, setDetails] = useState("");
  // const [file, setFile] = useState({});
  // const [resource, setResource] = useState({});

  const { user } = useAuth();

  useEffect(() => {
    fetch("https://apichothaon1-hzrifat.b4a.run/serieses")
      .then((res) => res.json())
      .then((data) =>
        setSerieses(
          data?.map((d) => {
            return d?.name;
          })
        )
      );
  }, []);

  useEffect(() => {
    fetch("https://apichothaon1-hzrifat.b4a.run/depts")
      .then((res) => res.json())
      .then((data) =>
        setDepartments(
          data?.map((d) => {
            return d?.code;
          })
        )
      );
  }, []);

  useEffect(() => {
    fetch("https://apichothaon1-hzrifat.b4a.run/semesters")
      .then((res) => res.json())
      .then((data) =>
        setSemesters(
          data?.map((d) => {
            return d?.code;
          })
        )
      );
  }, []);

  useEffect(() => {
    department &&
      semester &&
      fetch(
        `https://apichothaon1-hzrifat.b4a.run/subjects/${department}${semester}`
      )
        .then((res) => res.json())
        .then((data) => setSubjects(data));
  }, [department, semester]);

  // console.log(serieses, departments, semesters, subjects, department, semester);

  const uploadFile = async (e) => {
    const options = {
      onFileUploadFinished: (file) => {
        e.target.style.opacity = "0.5";
        e.target.style.pointerEvents = "none";

        const uploadData = {
          series,
          dept: department,
          semester,
          subjectName: subject?.name,
          subject: subject?.code,
          title,
          details,
          email: user?.email,
          uploader: user?.displayName,
          fileName: file?.filename,
          handle: file?.handle,
          link: file?.url,
          status: false,
        };

        fetch("https://apichothaon1-hzrifat.b4a.run/upload", {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(uploadData),
        })
          .then((res) => res.json())
          .then((data) => {
            if (data?.acknowledged) {
              e.target.reset();
              e.target.style.opacity = "1";
              e.target.style.pointerEvents = "initial";
              window.alert("Uploaded!! CG4");
            } else {
              e.target.style.opacity = "1";
              e.target.style.pointerEvents = "initial";
              window.alert("Something Went Wrong!!");
            }
          })
          .catch((error) => {
            e.target.style.opacity = "1";
            e.target.style.pointerEvents = "initial";
            window.alert("Something Went Wrong!!");
          });
      },
    };
    client.picker(options).open();
  };

  const uploadResource = async (e) => {
    e.preventDefault();
    // if (resource?.type !== "application/pdf") return window.alert("Please upload a PDF!");

    await uploadFile(e);
    // console.log(file);

    // if (!file?.filename || !file?.handle || !file?.url) return;
    // console.log(file)
  };

  return (
    <div>
      <div
        style={{
          background: "linear-gradient(-90deg, #232323, white)",
          borderTop: "1px solid black",
          minHeight: "87vh",
        }}
        className="d-flex justify-content-center"
      >
        <div
          style={{
            width: "500px",
            minWidth: "250px",
            background: "rgba(255, 255, 255, 1)",
          }}
          className="mt-2 mb-0 border rounded shadow-lg px-5 pt-5 pb-1"
        >
          <form
            onSubmit={uploadResource}
            className="d-flex flex-column custom-form mt-4"
          >
            <div className="d-flex">
              <div className="w-50">
                <label className="mb-2" style={{ fontWeight: "500" }}>
                  Series <span className="text-danger">*</span>
                </label>
                <select
                  className="me-2"
                  required
                  onChange={(e) => setSeries(Number(e?.target?.value))}
                >
                  <option value="">Select</option>
                  {serieses?.map((s, i) => {
                    return (
                      <option key={i} value={s}>
                        {s}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="w-50">
                <label className="ms-2 mb-2" style={{ fontWeight: "500" }}>
                  Department <span className="text-danger">*</span>
                </label>
                <select
                  className="ms-2"
                  required
                  onChange={(e) => setDepartment(e?.target?.value)}
                >
                  <option value="">Select</option>
                  {departments?.map((d, i) => {
                    return (
                      <option key={i} value={d}>
                        {d}
                      </option>
                    );
                  })}
                </select>
              </div>
            </div>

            <div className="d-flex">
              <div className="w-50">
                <label className="mb-2" style={{ fontWeight: "500" }}>
                  Semester <span className="text-danger">*</span>
                </label>
                <select
                  className="me-2"
                  required
                  onChange={(e) => setSemester(Number(e?.target?.value))}
                >
                  <option value="">Select</option>
                  {semesters?.map((s, i) => {
                    return (
                      <option key={i} value={s}>
                        {s?.toString()?.split("")?.join("-")}
                      </option>
                    );
                  })}
                </select>
              </div>
              <div className="w-50">
                <label className="ms-2 mb-2" style={{ fontWeight: "500" }}>
                  Subject <span className="text-danger">*</span>
                </label>
                <select
                  className="ms-2"
                  required
                  onChange={(e) =>
                    setSubject({
                      name: e?.target?.value?.split(", ")[0],
                      code: e?.target?.value?.split(", ")[1],
                    })
                  }
                >
                  <option value="">Select</option>
                  {subjects?.map((s, i) => {
                    return (
                      <option
                        key={i}
                        value={`${s?.name}, ${s?.code}${s?.ext}`}
                      >{`${s?.code}${s?.ext} - ${s?.name}`}</option>
                    );
                  })}
                </select>
              </div>
            </div>

            <label className="mb-2" style={{ fontWeight: "500" }}>
              Title <span className="text-danger">*</span>
            </label>
            <input
              required
              type="text"
              onChange={(e) => setTitle(e?.target?.value)}
              placeholder="Enter Title"
              className="ps-2"
            />

            <label className="mb-2" style={{ fontWeight: "500" }}>
              Details
            </label>
            <textarea
              onChange={(e) => setDetails(e?.target?.value)}
              placeholder="Some Details.."
              className="ps-2 pt-1"
            />

            {/* <label className="mb-2" style={{fontWeight: "500"}}>Resource <span className="text-danger">**</span></label> */}
            {/* <input required style={{border: "none"}} type="file" accept="application/pdf" onChange={(e) => setResource(e?.target?.files[0])} /> */}
            {/* <input  style={{border: "none"}} type="text" /> */}

            {/* <div>
                            <button type="button" onClick={fileUpload}>Choose File</button>
                        </div> */}

            <div className="mt-4 mb-2">
              <input
                className="btn-custom mb-0"
                type="submit"
                value="Upload!"
              />
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Upload;
